import PropTypes from 'prop-types';
import { variants, th } from 'style/theme';
import styled, { css } from 'styled-components';

/**
 * @deprecated use gen.2 Typography instead
 */
const A = styled.a.attrs({ target: '_blank', rel: 'noopener noreferrer' })`
  cursor: pointer;

  ${variants('variant', {
    primary: css`
      color: ${th('colors.primaryLink.default')};

      :hover {
        color: ${th('colors.primaryLink.hover')};
      }
    `,
    secondary: css`
      color: ${th('colors.secondaryLink.default')};

      :hover {
        color: ${th('colors.secondaryLink.hover')};
      }
    `,
    dark: css`
      color: ${th('colors.darkLink.default')};

      :hover {
        color: ${th('colors.darkLink.hover')};
      }
    `,
    light: css`
      color: ${th('colors.lightLink.default')};

      :hover {
        color: ${th('colors.lightLink.hover')};
      }
    `
  })}
`;

A.propTypes = {
  href: PropTypes.string.isRequired,
  variant: PropTypes.string
};

A.defaultProps = {
  variant: 'primary'
};

export default A;
